<template>
    <van-card
        :price="item.deposit + item.channel_amount + item.shop_server_amount"
        :thumb="item.img_url"
        class="order-item"
        @click="viewOrder"
    >
        <template slot="title">
           <div class="title">
                {{ item.usedcar_title }}
           </div>
        </template>
        <template slot="num">
            <div class="num">
                {{ item.state_name }}
            </div>
        </template>
        <template slot="desc">
            <div class="desc">
                {{ item.create_date | moment("YYYY-MM-DD HH:mm:ss") }}
            </div>
        </template>
        <template slot="tags">
            <div class="tags">
                {{ item.pay_style_name }} {{ item.receive_style_name}}
            </div>
        </template>
    </van-card>
</template>

<script>
import { 
    Panel,
    Image,
    Row,
    Col,
    Cell,
    Card
} from 'vant'

export default {
    name: 'OrderListItem',
    components: {
        [Panel.name]: Panel,
        [Image.name]: Image,
        [Row.name]: Row,
        [Col.name]: Col,
        [Cell.name]: Cell,
        [Card.name]: Card
    },
    props: ['item'],
    data() {
        return {}
    },
    methods: {
        viewOrder() {
            console.log('in item')
            console.log(this.data)
            this.$router.push(`/nt/usedcarorderview/${this.item.id}/`)
        }
    }
}
</script>

<style lang="less" scoped>
.order-item {
    .title {
        font-size: 1.1em;
        font-weight: bold;
        margin-bottom: 4px;
    }
    .desc {

    }
    .tags {

    }
}
</style>
